export enum WEBLAB_NAME {
  ASX_REBRANDING = 'ASX_REBRANDING_1271116',
  SUPPLIER_MY_DATA_LINK = 'ASX_1355758',
  ACCS_STOREFRONT_LISTING = 'ACCS_STOREFRONT_LISTING_1418883',
  ACCS_UK_LAUNCH = 'ACCS_UK_LAUNCH_1421339',
  ACCS_UK_ORDERING = 'ASX_ACCS_UK_ORDERING_1429872',
}

export enum WEBLAB_TREATMENT {
  C = 'C',
  T1 = 'T1',
}

// Builds an in memory cache of Weblab treatments injected in the html header's <meta> tag by Mons
// Adapted from: https://w.amazon.com/bin/view/Mons/Weblab/Configuration/#HDeliveryFrontend:HTMLResponseMetaTagFormat
function buildWeblabCache(): Record<string, string> {
  const weblabContent = document.head.querySelector('meta[name="a2z:mons_weblab_treatment"]')?.getAttribute('content');
  if (!weblabContent) {
    return {};
  }

  const weblabCache = weblabContent.split(',').reduce((obj, weblabNameTreatment) => {
    const [thisWeblabName, treatment] = weblabNameTreatment.split('=', 2);
    return {
      ...obj,
      [thisWeblabName as WEBLAB_NAME]: treatment as WEBLAB_TREATMENT,
    };
  }, {});

  return weblabCache;
}

const weblabCache = buildWeblabCache();

export const getTreatment = (weblab: WEBLAB_NAME): WEBLAB_TREATMENT | undefined =>
  weblabCache[weblab] as WEBLAB_TREATMENT;

export const isWeblabInTreatmentOne = (weblab: WEBLAB_NAME): boolean => WEBLAB_TREATMENT.T1 === getTreatment(weblab);

export const isRebrandingWeblabEnabled = isWeblabInTreatmentOne(WEBLAB_NAME.ASX_REBRANDING);

export const isSupplierMyDataEnabled = isWeblabInTreatmentOne(WEBLAB_NAME.SUPPLIER_MY_DATA_LINK);

export const isStorefrontListingEnabled = isWeblabInTreatmentOne(WEBLAB_NAME.ACCS_STOREFRONT_LISTING);

export const isUkLaunchEnabled = isWeblabInTreatmentOne(WEBLAB_NAME.ACCS_UK_LAUNCH);

export const isUkOrderingEnabled = isWeblabInTreatmentOne(WEBLAB_NAME.ACCS_UK_ORDERING);
